import { kebabCase as v } from "./index.es7.js";
import l, { useMemo as a, useCallback as A } from "react";
import { getParentMinMaxValue as y, findAncestorOfType as F, createFindIndicatorValue as P, createFormatter as R, currentQueryParamsString as T } from "./index.es4.js";
import L from "./index.es158.js";
import { indicatorNameClass as S, indicatorValueClass as C, indicatorSpreadClass as B } from "./index.es80.js";
import O from "./index.es159.js";
const z = ({
  indicator: e,
  region: t,
  compareScope: s,
  primaryRegion: $,
  comparisonRegions: u,
  categories: p,
  indicatorValues: r,
  slug: b,
  group: k
}) => {
  const w = a(
    () => y(r),
    [r]
  ), m = a(
    () => F(t, s),
    [t, s]
  ), n = a(
    () => w(e.indicatorApiId)(t, s),
    [e, t, s]
  ), d = a(
    () => `spread-${t.regionCode}-${e.indicatorApiId}`,
    [t, e]
  ), o = A(
    P(r),
    [r]
  ), f = A(R(p), [p]), E = a(
    () => o(t, e.indicatorApiId),
    [t, e]
  ), V = a(
    () => m ? o(m, e.indicatorApiId) : null,
    [m, e]
  ), x = a(
    () => f(e, E),
    [e, E]
  ), _ = a(
    () => f(e, V),
    [e, V]
  ), h = a(
    () => 1 + u.length,
    [u]
  ), N = a(
    () => s === "Country" ? "Norge" : m?.name || "",
    [s, m]
  ), c = a(
    () => o(t, e.indicatorApiId),
    [t, e]
  ), I = a(
    () => typeof c == "number" ? { markValue: c } : {},
    [c]
  ), M = a(
    () => n ? {
      min: n.min,
      max: n.max,
      midValue: n.value,
      id: d,
      scopeName: N,
      regionName: t.name,
      ...I
    } : null,
    [n, d, N, t, I]
  );
  return /* @__PURE__ */ l.createElement("tr", null, t === $ && /* @__PURE__ */ l.createElement("th", { className: S, rowSpan: h, scope: "row" }, /* @__PURE__ */ l.createElement(
    O,
    {
      className: "bl-link",
      href: `/${process.env.NEXT_PUBLIC_STATS_BASE_URL}/monitor/${b}/${k.slug}${T()}#${v(e.title)}`
    },
    e.title
  )), u.length > 0 && /* @__PURE__ */ l.createElement("th", { scope: "row" }, t.name), /* @__PURE__ */ l.createElement("td", { className: C }, x), /* @__PURE__ */ l.createElement("td", { className: C }, !!m && /* @__PURE__ */ l.createElement(l.Fragment, null, _)), /* @__PURE__ */ l.createElement("td", { className: B }, M && /* @__PURE__ */ l.createElement(L, { ...M })));
};
export {
  z as default
};
//# sourceMappingURL=index.es81.js.map
